{
  "identities.messages.1010001": "התחבר",
  "identities.messages.1010002": "התחבר עם {provider}",
  "identities.messages.1010003": "אנא אשר פעולה זו על ידי אימות שזה אתה.",
  "identities.messages.1010004": "אנא השלם את אתגר האימות השני.",
  "identities.messages.1010005": "אמת",
  "identities.messages.1010006": "קוד אימות",
  "identities.messages.1010007": "קוד שחזור גיבוי",
  "identities.messages.1010008": "המשך עם מפתח חומרה",
  "identities.messages.1010009": "המשך",
  "identities.messages.1010010": "המשך",
  "identities.messages.1010011": "התחבר עם מפתח חומרה",
  "identities.messages.1010012": "הכן את מכשיר ה-WebAuthn שלך (למשל מפתח אבטחה, סורק ביומטרי, ...) ולחץ על המשך.",
  "identities.messages.1010013": "המשך",
  "identities.messages.1010014": "קוד נשלח לכתובת שסיפקת. אם לא קיבלת אותו, אנא בדוק את איות הכתובת ונסה שוב.",
  "identities.messages.1010015": "שלח קוד התחברות",
  "identities.messages.1010016": "ניסית להתחבר עם \"{duplicateIdentifier}\", אך אימייל זה כבר בשימוש של חשבון אחר. התחבר לחשבונך עם אחת מהאפשרויות למטה כדי להוסיף את חשבונך \"{duplicateIdentifier}\" ב-\"{provider}\" כדרך נוספת להתחברות.",
  "identities.messages.1010017": "התחבר וקשר",
  "identities.messages.1010018": "אשר עם {provider}",
  "identities.messages.1010019": "בקש קוד כדי להמשיך",
  "identities.messages.1010021": "התחבר עם מפתח גישה",
  "identities.messages.1010022": "התחבר עם סיסמה",
  "identities.messages.1010023": "שלח קוד ל-{address}",
  "identities.messages.1040001": "הירשם",
  "identities.messages.1040002": "הירשם עם {provider}",
  "identities.messages.1040003": "המשך",
  "identities.messages.1040004": "הירשם עם מפתח אבטחה",
  "identities.messages.1040005": "קוד נשלח לכתובת/ות שסיפקת. אם לא קיבלת הודעה, בדוק את איות הכתובת ונסה שוב את ההרשמה.",
  "identities.messages.1040006": "שלח קוד הרשמה",
  "identities.messages.1040007": "הירשם עם מפתח גישה",
  "identities.messages.1040008": "חזור",
  "identities.messages.1040009": "אנא בחר אישור לאימות עצמך.",
  "identities.messages.1050001": "השינויים שלך נשמרו!",
  "identities.messages.1050002": "קשר {provider}",
  "identities.messages.1050003": "בטל קישור {provider}",
  "identities.messages.1050004": "בטל קישור אפליקציית אימות TOTP",
  "identities.messages.1050005": "קוד QR של אפליקציית אימות",
  "identities.messages.1050006": "{secret}",
  "identities.messages.1050007": "גלה קודי שחזור גיבוי",
  "identities.messages.1050008": "הפעל",
  "identities.messages.1050009": "{secret}",
  "identities.messages.1050010": "אלו הם קודי שחזור הגיבוי שלך. אנא שמור אותם במקום בטוח!",
  "identities.messages.1050011": "אשר קודי שחזור גיבוי",
  "identities.messages.1050012": "הוסף מפתח אבטחה",
  "identities.messages.1050013": "שם מפתח האבטחה",
  "identities.messages.1050014": "סוד נעשה שימוש ב-{used_at, date, long}",
  "identities.messages.1050015": "{secrets_list}",
  "identities.messages.1050016": "השבת שיטה זו",
  "identities.messages.1050017": "סוד אימות",
  "identities.messages.1050018": "הסר מפתח אבטחה \"{display_name}\"",
  "identities.messages.1050019": "הוסף מפתח גישה",
  "identities.messages.1050020": "הסר מפתח גישה \"{display_name}\"",
  "identities.messages.1060001": "שחזרת בהצלחה את חשבונך. אנא שנה את הסיסמה שלך או הגדר שיטת כניסה חלופית (למשל כניסה חברתית) בתוך {privileged_session_expires_at_unix_until_minutes} הדקות הבאות.",
  "identities.messages.1060002": "אימייל המכיל קישור לשחזור נשלח לכתובת האימייל שסיפקת. אם לא קיבלת אימייל, בדוק את איות הכתובת ווודא שאתה משתמש בכתובת שנרשמת איתה.",
  "identities.messages.1060003": "אימייל המכיל קוד שחזור נשלח לכתובת האימייל שסיפקת. אם לא קיבלת אימייל, בדוק את איות הכתובת ווודא שאתה משתמש בכתובת שנרשמת איתה.",
  "identities.messages.1060004": "קוד שחזור נשלח ל-\"{masked_address}\". אם לא קיבלת אותו, בדוק את איות הכתובת ווודא שאתה משתמש בכתובת שנרשמת איתה.",
  "identities.messages.1060005": "שחזר גישה לחשבונך על ידי מתן כתובת השחזור שלך במלואה.",
  "identities.messages.1060006": "איך תרצה לשחזר את חשבונך?",
  "identities.messages.1060007": "חזור",
  "identities.messages.1070001": "סיסמה",
  "identities.messages.1070002": "{title}",
  "identities.messages.1070003": "שמור",
  "identities.messages.1070004": "מזהה",
  "identities.messages.1070005": "שלח",
  "identities.messages.1070006": "אמת קוד",
  "identities.messages.1070007": "אימייל",
  "identities.messages.1070008": "שלח קוד שוב",
  "identities.messages.1070009": "המשך",
  "identities.messages.1070010": "קוד שחזור",
  "identities.messages.1070011": "קוד אימות",
  "identities.messages.1070012": "קוד הרשמה",
  "identities.messages.1070013": "קוד כניסה",
  "identities.messages.1070014": "התחבר וקשר אישור",
  "identities.messages.1070015": "אנא השלם את אתגר ה-captcha כדי להמשיך.",
  "identities.messages.1070016": "כתובת שחזור",
  "identities.messages.1070017": "מספר טלפון",
  "identities.messages.1080001": "אימייל המכיל קישור אימות נשלח לכתובת האימייל שסיפקת. אם לא קיבלת אימייל, בדוק את איות הכתובת ווודא שאתה משתמש בכתובת שנרשמת איתה.",
  "identities.messages.1080002": "אימתת בהצלחה את כתובת האימייל שלך.",
  "identities.messages.1080003": "אימייל המכיל קוד אימות נשלח לכתובת האימייל שסיפקת. אם לא קיבלת אימייל, בדוק את איות הכתובת ווודא שאתה משתמש בכתובת שנרשמת איתה.",
  "identities.messages.4000001": "{reason}",
  "identities.messages.4000002": "אנא הזן את ה-{property} ונסה שוב.",
  "identities.messages.4000003": "אורך חייב להיות >= {min_length}, אך קיבלת {actual_length}",
  "identities.messages.4000004": "לא תואם לתבנית \"{pattern}\"",
  "identities.messages.4000005": "לא ניתן להשתמש בסיסמה בגלל {reason}.",
  "identities.messages.4000006": "האישורים שסופקו אינם תקינים, בדוק טעויות איות בסיסמה או שם משתמש, כתובת אימייל או מספר טלפון.",
  "identities.messages.4000007": "חשבון עם אותו מזהה (אימייל, טלפון, שם משתמש, ...) כבר קיים.",
  "identities.messages.4000008": "קוד האימות שסופק אינו תקין, אנא נסה שוב.",
  "identities.messages.4000009": "לא נמצאו מזהי כניסה. שכחת להגדיר אותם? זה יכול להיגרם גם מתצורה שגויה של השרת.",
  "identities.messages.4000010": "החשבון עדיין לא פעיל. שכחת לאמת את כתובת האימייל שלך?",
  "identities.messages.4000011": "אין לך מכשיר TOTP מוגדר.",
  "identities.messages.4000012": "קוד שחזור הגיבוי הזה כבר נעשה בו שימוש.",
  "identities.messages.4000013": "אין לך מכשיר WebAuthn מוגדר.",
  "identities.messages.4000014": "אין לך קודי שחזור גיבוי מוגדרים.",
  "identities.messages.4000015": "חשבון זה לא קיים או שאין לו מפתח אבטחה מוגדר.",
  "identities.messages.4000016": "קוד שחזור הגיבוי אינו תקין.",
  "identities.messages.4000017": "אורך חייב להיות <= {max_length}, אך קיבלת {actual_length}",
  "identities.messages.4000018": "חייב להיות >= {minimum} אך נמצא {actual}",
  "identities.messages.4000019": "חייב להיות > {minimum} אך נמצא {actual}",
  "identities.messages.4000020": "חייב להיות <= {maximum} אך נמצא {actual}",
  "identities.messages.4000021": "חייב להיות < {maximum} אך נמצא {actual}",
  "identities.messages.4000022": "{actual} לא מכפלה של {base}",
  "identities.messages.4000023": "מקסימום {max_items} פריטים מותרים, אך נמצאו {actual_items} פריטים",
  "identities.messages.4000024": "מינימום {min_items} פריטים מותרים, אך נמצאו {actual_items} פריטים",
  "identities.messages.4000025": "פריטים באינדקס {index_a} ו-{index_b} שווים",
  "identities.messages.4000026": "צפוי {allowed_types_list}, אך קיבלת {actual_type}",
  "identities.messages.4000027": "חשבון עם אותו מזהה (אימייל, טלפון, שם משתמש, ...) כבר קיים. אנא התחבר לחשבון הקיים שלך כדי לקשר את הפרופיל החברתי שלך.",
  "identities.messages.4000028": "ניסית להתחבר עם {credential_identifier_hint} שכבר בשימוש של חשבון אחר. תוכל להתחבר באמצעות {available_credential_types_list}. תוכל להתחבר באמצעות אחד מספקי הכניסה החברתית הבאים: {available_oidc_providers_list}.",
  "identities.messages.4000029": "חייב להיות שווה לקבוע {expected}",
  "identities.messages.4000030": "const נכשל",
  "identities.messages.4000031": "לא ניתן להשתמש בסיסמה מכיוון שהיא דומה מדי למזהה.",
  "identities.messages.4000032": "הסיסמה חייבת להיות באורך של לפחות {min_length} תווים, אך קיבלת {actual_length}.",
  "identities.messages.4000033": "הסיסמה יכולה להיות באורך של לכל היותר {max_length} תווים, אך קיבלת {actual_length}.",
  "identities.messages.4000034": "הסיסמה נמצאה בדליפות מידע ואסור עוד להשתמש בה.",
  "identities.messages.4000035": "חשבון זה לא קיים או שלא הגדיר כניסה עם קוד.",
  "identities.messages.4000036": "המאפיינים שסופקו אינם תואמים למאפיינים שקושרו בעבר לתהליך זה.",
  "identities.messages.4000037": "חשבון זה לא קיים או שאין לו שיטת כניסה מוגדרת.",
  "identities.messages.4000038": "אימות captcha נכשל, אנא נסה שוב.",
  "identities.messages.4010001": "החיבור פג תוקף. אנא נסה שוב.",
  "identities.messages.4010002": "לא נמצאה אסטרטגיה להתחברות. מילאת את הטופס נכון?",
  "identities.messages.4010003": "לא נמצאה אסטרטגיה להרשמה. מילאת את הטופס נכון?",
  "identities.messages.4010004": "לא נמצאה אסטרטגיה לעדכון ההגדרות שלך. מילאת את הטופס נכון?",
  "identities.messages.4010005": "לא נמצאה אסטרטגיה לשחזור החשבון שלך. מילאת את הטופס נכון?",
  "identities.messages.4010006": "לא נמצאה אסטרטגיה לאימות החשבון שלך. מילאת את הטופס נכון?",
  "identities.messages.4010007": "הבקשה כבר הושלמה בהצלחה ולא ניתן לחזור עליה.",
  "identities.messages.4010008": "קוד הכניסה אינו תקין או שכבר נעשה בו שימוש. אנא נסה שוב.",
  "identities.messages.4010009": "אישורים מקושרים אינם תואמים.",
  "identities.messages.4010010": "הכתובת שהזנת אינה תואמת לאף כתובת ידועה בחשבון הנוכחי.",
  "identities.messages.4040001": "החיבור פג תוקף. אנא נסה שוב.",
  "identities.messages.4040002": "הבקשה כבר הושלמה בהצלחה ולא ניתן לחזור עליה.",
  "identities.messages.4040003": "קוד ההרשמה אינו תקין או שכבר נעשה בו שימוש. אנא נסה שוב.",
  "identities.messages.4050001": "החיבור פג תוקף. אנא נסה שוב.",
  "identities.messages.4060001": "הבקשה כבר הושלמה בהצלחה ולא ניתן לחזור עליה.",
  "identities.messages.4060002": "תהליך השחזור הגיע למצב כשל ויש לנסות שוב.",
  "identities.messages.4060004": "אסימון השחזור אינו תקין או שכבר נעשה בו שימוש. אנא נסה שוב את התהליך.",
  "identities.messages.4060005": "החיבור פג תוקף. אנא נסה שוב.",
  "identities.messages.4060006": "קוד השחזור אינו תקין או שכבר נעשה בו שימוש. אנא נסה שוב.",
  "identities.messages.4070001": "אסימון האימות אינו תקין או שכבר נעשה בו שימוש. אנא נסה שוב את התהליך.",
  "identities.messages.4070002": "הבקשה כבר הושלמה בהצלחה ולא ניתן לחזור עליה.",
  "identities.messages.4070003": "תהליך האימות הגיע למצב כשל ויש לנסות שוב.",
  "identities.messages.4070005": "החיבור פג תוקף. אנא נסה שוב.",
  "identities.messages.4070006": "קוד האימות אינו תקין או שכבר נעשה בו שימוש. אנא נסה שוב.",
  "identities.messages.5000001": "{reason}",
  "login.logout-button": "התנתק",
  "login.registration-button": "הירשם",
  "login.registration-label": "אין לך חשבון?",
  "login.title": "התחבר",
  "login.subtitle": "התחבר עם {parts}",
  "login.title-aal2": "אימות דו-שלבי",
  "login.subtitle-aal2": "בחר דרך להשלים את האימות הדו-שלבי שלך",
  "login.code.subtitle": "קוד אימות יישלח באימייל",
  "login.webauthn.subtitle": "אנא הכן את מכשיר ה-WebAuthN שלך",
  "login.totp.subtitle": "אנא הזן את הקוד שנוצר על ידי אפליקציית האימות שלך",
  "login.lookup_secret.subtitle": "אנא הזן אחד מקודי שחזור הגיבוי בני 8 הספרות שלך",
  "login.title-refresh": "אמת מחדש",
  "login.subtitle-refresh": "אשר את זהותך עם {parts}",
  "login.2fa.go-back": "משהו לא עובד?",
  "login.2fa.go-back.link": "חזור אחורה",
  "login.2fa.method.go-back": "בחר שיטה אחרת",
  "recovery.title": "שחזר את חשבונך",
  "recovery.subtitle": "הזן את המזהה המשויך לחשבונך כדי לקבל קוד גישה חד-פעמי",
  "registration.login-button": "התחבר",
  "registration.login-label": "כבר יש לך חשבון?",
  "registration.title": "רשום חשבון",
  "registration.subtitle": "הירשם עם {parts}",
  "settings.navigation-back-button": "חזור",
  "settings.subtitle": "עדכן את הגדרות החשבון שלך",
  "settings.title": "הגדרות חשבון",
  "settings.password.title": "שנה סיסמה",
  "settings.password.description": "שנה את הסיסמה שלך",
  "settings.profile.title": "הגדרות פרופיל",
  "settings.profile.description": "עדכן את פרטי הפרופיל שלך",
  "settings.webauthn.title": "נהל אסימוני חומרה",
  "settings.webauthn.description": "נהל את הגדרות אסימון החומרה שלך",
  "settings.messages.toast-title.success": "ההגדרות עודכנו",
  "settings.messages.toast-title.error": "לא ניתן לעדכן הגדרות",
  "verification.title": "אמת את חשבונך",
  "verification.subtitle": "הזן את כתובת האימייל המשויכת לחשבונך כדי לאמת אותו",
  "two-step.password.title": "סיסמה",
  "two-step.password.description": "הזן את הסיסמה המשויכת לחשבונך",
  "two-step.code.title": "קוד אימייל",
  "two-step.code.description": "קוד אימות יישלח לאימייל שלך",
  "two-step.webauthn.title": "מפתח אבטחה",
  "two-step.webauthn.description": "השתמש במפתח האבטחה שלך כדי לאמת",
  "two-step.passkey.title": "מפתח גישה (מומלץ)",
  "two-step.passkey.description": "השתמש במכשיר שלך לזיהוי טביעת אצבע או פנים",
  "two-step.passkey.description.error": "לא ניתן לטעון את הספריות הדרושות כדי להשתמש במפתח הגישה שלך. אנא נסה שוב מאוחר יותר.",
  "two-step.totp.title": "השתמש באפליקציית האימות שלך (TOTP)",
  "two-step.totp.description": "השתמש בקוד חד-פעמי בן 6 ספרות מאפליקציית האימות שלך",
  "two-step.lookup_secret.title": "קוד שחזור גיבוי",
  "two-step.lookup_secret.description": "השתמש באחד מקודי הגיבוי בני 8 הספרות שלך כדי לאמת",
  "input.placeholder": "הזן את ה-{placeholder} שלך",
  "card.header.parts.oidc": "ספק חברתי",
  "card.header.parts.password.registration": "ה-{identifierLabel} שלך וסיסמה",
  "card.header.parts.password.login": "ה-{identifierLabel} והסיסמה שלך",
  "card.header.parts.code": "קוד חד-פעמי",
  "card.header.parts.passkey": "מפתח גישה",
  "card.header.parts.webauthn": "מפתח אבטחה",
  "card.header.parts.totp": "אפליקציית האימות שלך",
  "card.header.parts.lookup_secret": "קוד שחזור גיבוי",
  "card.header.parts.identifier-first": "ה-{identifierLabel} שלך",
  "misc.or": "או",
  "forms.label.forgot-password": "שכחת סיסמה?",
  "forms.label.recover-account": "שחזר חשבון",
  "settings.totp.title": "אפליקציית אימות",
  "settings.totp.description": "הוסף אפליקציית אימות TOTP לחשבונך כדי לשפר את אבטחת החשבון שלך. אפליקציות אימות פופולריות הן LastPass ו-Google Authenticator",
  "settings.totp.info.not-linked": "כדי להפעיל, סרוק את קוד ה-QR עם האפליקציה שלך והזן את הקוד.",
  "settings.totp.info.linked": "יש לך כרגע אפליקציית אימות מחוברת.",
  "settings.lookup_secret.title": "קודי שחזור גיבוי (גורם שני)",
  "settings.lookup_secret.description": "קודי שחזור הם גיבוי מאובטח לאימות דו-שלבי, המאפשר לך לקבל מחדש גישה לחשבונך אם תאבד את מכשיר האימות הדו-שלבי שלך.",
  "settings.oidc.title": "חשבונות מקושרים",
  "settings.oidc.description": "קשר ספק כניסה חברתית לחשבונך.",
  "settings.oidc.info": "חשבונות מקושרים מספקים אלה יכולים לשמש להתחברות לחשבונך",
  "settings.webauthn.info": "אסימוני חומרה משמשים לאימות דו-שלבי או כגורם ראשון עם מפתחות גישה",
  "settings.passkey.title": "נהל מפתחות גישה",
  "settings.passkey.description": "נהל את הגדרות מפתח הגישה שלך",
  "settings.passkey.info": "נהל את הגדרות מפתח הגישה שלך",
  "card.footer.select-another-method": "בחר שיטה אחרת",
  "account-linking.title": "קשר חשבון",
  "property.password": "סיסמה",
  "property.email": "אימייל",
  "property.phone": "טלפון",
  "property.username": "שם משתמש",
  "property.identifier": "מזהה",
  "property.code": "קוד",
  "property.recovery_address": "כתובת שחזור",
  "consent.title": "אשר {party}",
  "consent.subtitle": "אפליקציית צד שלישי רוצה לגשת למידע המשויך לחשבונך {identifier}.",
  "consent.scope.openid.title": "זהות",
  "consent.scope.openid.description": "מאפשר לאפליקציה לאמת את זהותך. זה נדרש לאימות ולחוויית כניסה מהימנה.",
  "consent.scope.offline_access.title": "גישה לא מקוונת",
  "consent.scope.offline_access.description": "מאפשר לאפליקציה זו לשמור עליך מחובר גם כאשר אתה לא משתמש בה באופן פעיל.",
  "consent.scope.profile.title": "פרטי פרופיל",
  "consent.scope.profile.description": "מאפשר גישה לפרטי הפרופיל הבסיסיים שלך, כולל שם המשתמש, השם הפרטי ושם המשפחה שלך.",
  "consent.scope.email.title": "כתובת אימייל",
  "consent.scope.email.description": "אחזר את כתובת האימייל שלך ואת מצב האימות שלה.",
  "consent.scope.address.title": "כתובת פיזית",
  "consent.scope.address.description": "גישה לכתובת הדואר שלך.",
  "consent.scope.phone.title": "מספר טלפון",
  "consent.scope.phone.description": "אחזר את מספר הטלפון שלך ואת מצב האימות שלו.",
  "error.title.what-happened": "מה קרה?",
  "error.title.what-can-i-do": "מה אני יכול לעשות?",
  "error.instructions": "אנא נסה שוב בעוד כמה דקות או צור קשר עם מפעיל האתר.",
  "error.footer.text": "בעת דיווח על שגיאה זו, אנא כלול את המידע הבא:",
  "error.footer.copy": "העתק",
  "error.action.go-back": "חזור אחורה",
  "identities.messages.4000039": "הסיסמה החדשה חייבת להיות שונה מהסיסמה הישנה.",
  "identities.messages.4000040": "הזן כתובת אימייל חוקית",
  "identities.messages.4000041": "הזן מספר טלפון חוקי",
  "captcha.error": "אימות האבטחה נכשל. אנא נסה שוב מאוחר יותר. אם הבעיה נמשכת, פנה לתמיכה.",
  "identities.messages.5000002": "לא קיימות שיטות אימות זמינות. אנא צרו קשר עם מנהל המערכת.",
  "identities.messages.4010011": "החשבון הזה הושבת. אנא צרו קשר עם צוות התמיכה לקבלת עזרה.",
  "identities.messages.1070018": "כתובת דוא\"ל או מספר טלפון",
  "identities.messages.1080004": "הודעת טקסט המכילה קוד אימות נשלחה למספר הטלפון שסיפקת. אם לא קיבלת את הודעת הטקסט, בדוק את נכונות המספר וודא שאתה משתמש במספר שבו נרשמת.",
  "identities.messages.1080005": "אימתת בהצלחה את מספר הטלפון שלך.",
  "identities.messages.5000003": "הארגון שלכם דורש אימות באמצעות SSO, אך לא הוגדר ספק SSO. אנא צרו קשר עם מנהל המערכת.",
  "identities.messages.1010024": "התחברו באמצעות מפתח חומרה",
  "identities.messages.1010025": "קוד נשלח לכתובת שלך. אם לא קיבלת אותו, אנא נסה שוב.",
  "identities.messages.4000042": "לא הוגדר אצלכם מכשיר DeviceAuthn.",
  "identities.messages.4000043": "ההרשמה באמצעות אימות האינטרנט שסופק אינה תקינה, אנא נסו שוב.",
  "identities.messages.4000044": "החתימה של DeviceAuthn שסופקה אינה חוקית.",
  "identities.messages.4050002": "ניתן לשנות כתובת אחת בכל פעם. אנא עדכנו כל כתובת בנפרד."
}
